module.exports = __webpack_public_path__ + "static/media/dilaceracao.bb9bb6d2.jpeg";